<template>
  <v-dialog v-model="dialog" persistent max-width="600" scrollable>
    <v-card>
      <v-card-title>
        <v-icon left color="orange">mdi-progress-clock</v-icon>
        Update Task Status
      </v-card-title>
      <v-card-text v-if="task">
        <div class="mb-3">
          <strong>{{ task.task ? task.task.title : "" }}</strong>
          <div
            v-if="task.task && task.task.description"
            class="body-2 grey--text text--darken-1 mt-1"
            style="white-space: pre-wrap"
          >
            {{ task.task.description }}
          </div>
        </div>

        <v-divider class="mb-3"></v-divider>

        <!-- Status Selection -->
        <div class="mb-3">
          <div class="caption grey--text mb-1">Set Status</div>
          <v-radio-group v-model="selectedStatus" row dense class="mt-0">
            <v-radio label="Ongoing" value="ongoing" color="orange"></v-radio>
            <v-radio label="Pending" value="pending" color="grey"></v-radio>
          </v-radio-group>
        </div>

        <!-- Remark Input -->
        <v-textarea
          dense
          v-model="remark"
          label="Remark *"
          placeholder="Describe the current progress or update..."
          outlined
          rows="3"
          counter="500"
          maxlength="500"
          :rules="[(v) => !!v || 'Remark is required']"
        ></v-textarea>

        <!-- Existing Remarks Timeline -->
        <div v-if="remarks.length > 0" class="mt-2">
          <v-divider class="mb-3"></v-divider>
          <div class="caption grey--text mb-2">Previous Remarks</div>
          <div v-for="(r, i) in remarks" :key="i" class="d-flex mb-2">
            <v-icon
              small
              class="mr-2 mt-1"
              :color="r.status_set === 'ongoing' ? 'orange' : 'grey'"
            >
              {{
                r.status_set === "ongoing"
                  ? "mdi-progress-clock"
                  : "mdi-clock-outline"
              }}
            </v-icon>
            <div class="flex-grow-1">
              <div class="body-2">{{ r.remark }}</div>
              <div class="caption grey--text">
                <v-chip
                  x-small
                  :color="r.status_set === 'ongoing' ? 'orange' : 'grey'"
                  dark
                  class="mr-1"
                >
                  {{ r.status_set === "ongoing" ? "Ongoing" : "Pending" }}
                </v-chip>
                {{ r.user ? r.user.full_name : "" }}
                &middot;
                {{ formatDate(r.created_at) }}
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn
          color="orange"
          dark
          :loading="loading"
          :disabled="!remark.trim()"
          @click="submit"
        >
          <v-icon left>mdi-check</v-icon>
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    value: { type: Boolean, default: false },
    task: { type: Object, default: null },
  },
  data() {
    return {
      selectedStatus: "ongoing",
      remark: "",
      loading: false,
      remarks: [],
      loadingRemarks: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.remark = "";
        this.selectedStatus = "ongoing";
        this.loadRemarks();
      }
    },
  },
  methods: {
    ...mapActions({
      update_task_log_status: "reminder/update_task_log_status",
      get_task_log_remarks: "reminder/get_task_log_remarks",
      set_notification: "notification/set_notification",
    }),
    async loadRemarks() {
      if (!this.task) return;
      this.loadingRemarks = true;
      try {
        this.remarks = await this.get_task_log_remarks(this.task.id);
      } catch (e) {
        this.remarks = [];
      }
      this.loadingRemarks = false;
    },
    close() {
      this.dialog = false;
    },
    submit() {
      if (!this.task || !this.remark.trim() || this.loading) return;
      this.loading = true;
      this.update_task_log_status({
        logId: this.task.id,
        status: this.selectedStatus,
        remark: this.remark.trim(),
      })
        .then(() => {
          this.loading = false;
          this.set_notification({
            message:
              "Task status updated to " +
              (this.selectedStatus === "ongoing" ? "Ongoing" : "Pending"),
            type: "success",
          });
          this.$emit("updated");
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          const msg = err.response
            ? err.response.data.error || err.response.data.message
            : err.message;
          this.$alert({
            title: "Error",
            message: msg,
            color: "error",
            icon: "mdi-alert-circle",
          });
        });
    },
    formatDate(d) {
      if (!d) return "";
      return new Date(d).toLocaleString();
    },
  },
};
</script>
